import {
  AccessTokenStore,
  URLBuilder,
  isInIframe,
} from '@termly-web/common'

const UNAUTHORIZED = 401


/**
 * Ends a cookie session that the server stops accepting while the dashboard
 * sits in a partner's iframe.
 *
 * The partner that embeds the dashboard is the only way back into it, so a
 * refusal there leaves nothing on the page that can recover the session, and
 * the session-expired page says so. Outside an iframe the refusal is left to
 * whoever made the request.
 *
 * Only a refusal while no bearer token is held concerns this. A refused bearer
 * token is refreshed, or its session ended, before the failure gets here, and
 * a session ended that way empties the store, so it is sent to the same page a
 * second time at no cost.
 *
 * Navigates for real rather than routing, because this runs outside the React
 * tree.
 *
 * @param {Object} error - the error the request rejected with
 * @param {Object} [error.response] - the server's answer, absent when the
 *   request never earned one
 * @param {Number} [error.response.status]
 *
 * @returns {Promise} rejects with the same error, so that the caller still
 *   sees the failure
 */
export default function endIframeSessionOn401(error) {
  const isRefusedCookieSession = ( error.response?.status === UNAUTHORIZED && !AccessTokenStore.getAccessToken() )

  if ( isRefusedCookieSession && isInIframe() ) {
    window.location.assign(URLBuilder.sessionExpiredURL())
  }

  return Promise.reject(error)
}
